(ns frontend.view.nev.kyc.process.pdf-make-utils
  (:require
   [clojure.string :as string]
   [common.country :as country]
   [common.languages :as languages]
   [common.localization :as loc]
   [common.schema.entities.workspace.kyc.kyc-options :as kyc-options]
   [common.schema.entities.workspace.kyc.kyc-utils :as ku]
   [common.schema.entities.workspace.kyc.templates.template-registry :as template-registry]
   [common.schema.entities.workspace.kyc.templates.templates :as templates]
   [common.util :as cu]
   [frontend.db :as db]
   [frontend.logging :as logging]
   [frontend.state.current-session :as session]
   [frontend.utils :as fu]
   [frontend.view.nev.kyc.process.editor-utils :as editor-utils]
   [reagent.core :as r]))

;; Images for rendering check boxes
(def square-icon-data-url-v2 "data:image/png;base64,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")
(def square-check-big-icon-data-url-v2 "data:image/png;base64,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")

(defn html->pdfmake-elements
  [html-str]
  (js/htmlToPdfmake (clj->js html-str)))

(defn html->pdfmake-content
  [html-str styles]
  (let [paragraphs (->> (string/split html-str "<p>")
                        (mapcat (fn [p]
                                  (string/split p "</p>")))
                        (remove cu/empty-value?))]
    (->> paragraphs
         (map (fn [p]
                {:text  (html->pdfmake-elements p)
                 :style (:paragraph-style styles)})))))

(defn pdfmake-question-label
  [question-meta lang-kw]
  [{:text  (ku/localize question-meta [] lang-kw)
    :style :label}])

(def START-NEW-PAGE-PREFIX "PAGE_")

(def BOARD-MEMBER-PREFIX (str START-NEW-PAGE-PREFIX "BOARD_MEMBER_"))
(def PEP-ID-PREFIX (str START-NEW-PAGE-PREFIX "PEP_"))
(def UBO-ID-PREFIX (str START-NEW-PAGE-PREFIX "UBO_"))
(def SMO-ID-PREFIX (str START-NEW-PAGE-PREFIX "SMO_"))
(def SUSO-ID-PREFIX (str START-NEW-PAGE-PREFIX "SUSO_"))
(def CPER-ID-PREFIX (str START-NEW-PAGE-PREFIX "CPER_"))

(defn pep-pdfmake-id
  [pep]
  (str PEP-ID-PREFIX (ku/pep-display-name pep)))

(defn ubo-pdfmake-id
  [ubo]
  (str UBO-ID-PREFIX (:kyc-ubo/first-name ubo) "-" (:kyc-ubo/last-name ubo)))

(defn smo-pdfmake-id
  [smo]
  (str SMO-ID-PREFIX (:kyc-smo/first-name smo) "-" (:kyc-smo/last-name smo)))

(defn board-member-pdfmake-id
  [board-member]
  (str BOARD-MEMBER-PREFIX
       (:kyc-board-member/first-name board-member)
       "-"
       (:kyc-board-member/last-name board-member)))

(defn substantial-us-owner-pdfmake-id
  [suso]
  (str SUSO-ID-PREFIX (:kyc-substantial-us-owner/full-name suso)))

(defn controlling-person-pdfmake-id
  [idx cper]
  (str CPER-ID-PREFIX "_" idx "_" (:kyc-controlling-person/first-name cper) "-" (:kyc-controlling-person/last-name cper)))

(defmulti to-pdfmake-content-complex :edn-data/type)

(defmethod to-pdfmake-content-complex :default
  [args]
  (let [edn-type (:edn-data/type args)]
    (logging/warn "KYC complex data not supported to PDFMake conversion " edn-type
                  " << " (type edn-type))
    {:text  (str (:value args))
     :style :value}))

;; TODO: Add support for radio if needed
(defmethod to-pdfmake-content-complex :edn-data.type/combo-checkbox-selection
  [{:keys [value lang-kw] :as args}]
  (let [parent-checked? (:checked? value)
        checked-children (-> value
                             :checked-children
                             set)
        question-meta (or (:question-meta args) args)
        parent-label (ku/localize question-meta [] lang-kw)
        children (:children question-meta)
        _selection-mode (:selection-mode question-meta)]

    {:stack
     [{:columns
       [{:image  (if parent-checked?
                   square-check-big-icon-data-url-v2
                   square-icon-data-url-v2)
         :width  10
         :height 10}
        {:width    "*"
         :text     parent-label
         :style    :value
         :fontSize 10
         :margin   [5 0 0 0]}]
       :margin [0 8 0 5]}

      (when (seq children)
        {:stack
         (->> children
              (map (fn [child]
                     (let [child-key (:key child)
                           child-checked? (and parent-checked?
                                               (contains? checked-children child-key))
                           child-label (if (map? (:label child))
                                         (get (:label child) lang-kw
                                              (get (:label child) :en ""))
                                         (if (keyword? (:label child))
                                           (loc/tr (:label child) nil lang-kw)
                                           (:label child)))]
                       {:columns
                        [{:width 20
                          :text  ""}
                         {:image  (if child-checked?
                                    square-check-big-icon-data-url-v2
                                    square-icon-data-url-v2)
                          :width  10
                          :height 10}
                         {:width    "*"
                          :text     child-label
                          :style    :value
                          :fontSize 10
                          :margin   [5 0 0 0]}]
                        :margin [0 5 3 5]})))
              (doall)
              (vec))})]}))

(defn board-members-for-pdf
  [board-members kyc-process-status]
  (let [included-statuses (cond-> #{:confirmed-by-customer}
                            (= kyc-process-status :kyc-process.status/draft)
                            (conj :confirmed-by-controller))]
    (filterv (fn [board-member]
               (contains? included-statuses
                          (:kyc-board-member/confirmation-status board-member)))
             board-members)))

(defmethod to-pdfmake-content-complex :edn-data.type/board-members-list
  [{:keys [value lang-kw kyc-process-status] :as args}]
  (let [board-member-list (board-members-for-pdf value kyc-process-status)
        questions (-> args
                      :data/template
                      :kyc-board-member.group/basic-information
                      :questions)
        headers [:kyc-board-member/first-name :kyc-board-member/middle-names
                 :kyc-board-member/last-name :kyc-board-member/role
                 :kyc-board-member/dob (if (contains? questions :kyc-board-member/nationalities)
                                         :kyc-board-member/nationalities
                                         :kyc-board-member/country)]
        column-widths (vec (repeat (count headers) "16.66%"))]
    (if (empty? board-member-list)
      {:table {:widths     column-widths
               :headerRows 1
               :body       (concat
                            [(->> (range (count headers))
                                  (mapv (fn [i]
                                          {:text      (if (= i 0) (ku/localize args [] lang-kw) "")
                                           :style     :table-header
                                           :margin    [0 2 0 2]
                                           :colSpan   (count headers)
                                           :border    [false false false false]
                                           :fillColor "#FFFFFF"})))]
                            [(->> (range (count headers))
                                  (mapv (fn [i]
                                          {:text      (if (= i 0) "-" "")
                                           :border    [false false false false]
                                           :fillColor "#FFFFFF"})))])}}

      {:table
       {:widths     column-widths
        :headerRows 2
        :body
        (concat
         [(->> (range (count headers))
               (mapv (fn [i]
                       {:text      (if (= i 0) (ku/localize args [] lang-kw) "")
                        :style     :table-header
                        :margin    [0 2 0 2]
                        :colSpan   (count headers)
                        :border    [false false false true]
                        :fillColor "#FFFFFF"})))]
         [(->> headers
               (mapv (fn [attr]
                       {:text        (-> questions
                                         (get attr)
                                         :translations
                                         (get lang-kw))
                        :border      [true true true true]
                        :borderColor ["#DDD" "#DDD" "#DDD" "#DDD"]
                        :fillColor   "#EEE"})))]
         (->>
          board-member-list
          (mapv
           (fn [board-member]
             (let [first-name (:kyc-board-member/first-name board-member)
                   middle-names (:kyc-board-member/middle-names board-member)
                   last-name (:kyc-board-member/last-name board-member)
                   date-of-birth (fu/format-date-ts (:kyc-board-member/dob board-member) "/")
                   country (ku/nationality-labels board-member
                                                  {:nationality-keys ku/board-member-nationality-keys
                                                   :lang-kw          lang-kw})
                   role-kw (:kyc-board-member/role board-member)
                   role-options (-> questions
                                    (get :kyc-board-member/role)
                                    :options)
                   role-translations (->> role-options
                                          (filter (fn [option]
                                                    (= (:key option) role-kw)))
                                          (first)
                                          :translations)
                   role (get role-translations lang-kw)]

               (->> [first-name middle-names last-name role date-of-birth country]
                    (mapv (fn [text-value]
                            {:text        text-value
                             :border      [true true true true]
                             :style       :value
                             :borderColor ["#DDD" "#DDD" "#DDD" "#DDD"]}))))))))}})))

(defmethod to-pdfmake-content-complex :edn-data.type/ubo-list
  [{:keys [value]}]
  (let [ubo-list value]
    {:stack (->> ubo-list
                 (map (fn [ubo]
                        {:text              (->> [(:kyc-ubo/first-name ubo)
                                                  (:kyc-ubo/middle-names ubo)
                                                  (:kyc-ubo/last-name ubo)]
                                                 (remove string/blank?)
                                                 (string/join " "))
                         :style             :link
                         :linkToDestination (ubo-pdfmake-id ubo)})))}))

(defmethod to-pdfmake-content-complex :edn-data.type/smo-list
  [{:keys [value]}]
  (let [smo-list value]
    {:stack (->> smo-list
                 (map (fn [smo]
                        {:text              (str (:kyc-smo/first-name smo) " " (:kyc-smo/last-name smo))
                         :style             :link
                         :linkToDestination (smo-pdfmake-id smo)})))}))

(defmethod to-pdfmake-content-complex :edn-data.type/pep-list
  [{:keys [value]}]
  (let [pep-list value]
    {:stack (->> pep-list
                 (map (fn [pep]
                        {:text              (ku/pep-display-name pep)
                         :style             :link
                         :linkToDestination (pep-pdfmake-id pep)})))}))

(defmethod to-pdfmake-content-complex :edn-data.type/substantial-us-owner-list
  [{:keys [value]}]
  (let [suso-list value]
    {:stack (->> suso-list
                 (map (fn [suso]
                        {:text              (or (:kyc-substantial-us-owner/full-name suso) "")
                         :style             :link
                         :linkToDestination (substantial-us-owner-pdfmake-id suso)})))}))

(defmethod to-pdfmake-content-complex :edn-data.type/controlling-person-list
  [{:keys [value]}]
  (let [cper-list value]
    {:stack (->> cper-list
                 (map-indexed (fn [idx cper]
                                {:text              (str (or (:kyc-controlling-person/first-name cper) "") " " (or (:kyc-controlling-person/last-name cper) ""))
                                 :style             :link
                                 :linkToDestination (controlling-person-pdfmake-id idx cper)})))}))

(defmethod to-pdfmake-content-complex :edn-data.type/string-array
  [{:keys [value]}]
  (let [items (or value [])]
    (if (seq items)
      {:stack (->> items
                   (map (fn [s]
                          {:text  (str s)
                           :style :value}))
                   (doall))}
      {:text  "-"
       :style :value})))

(defmethod to-pdfmake-content-complex :edn-data.type/nationalities
  [{:keys [question-kw answers value lang-kw]}]
  (let [nationality-rows (if (and question-kw answers)
                           (ku/nationality-rows answers
                                                (ku/nationality-keys-for question-kw))
                           value)]
    {:stack (->> nationality-rows
                 (sort-by :ord)
                 (map (fn [{:keys [nationality id-number]}]
                        {:text  (->> [(country/get-label nationality lang-kw)
                                      id-number]
                                     (remove cu/blank-value?)
                                     (string/join " - "))
                         :style :value}))
                 (doall))}))

(defmethod to-pdfmake-content-complex :edn-data.type/tax-recidencies
  [{:keys [value lang-kw]}]
  (let [tax-residencies-list value]
    {:stack (->> tax-residencies-list
                 (map (fn [tax-residency]
                        (let [{:keys [country tin tin-missing-reason tin-status]} tax-residency
                              country-name (country/get-label country lang-kw)]
                          {:text  (->> [country-name tin tin-missing-reason
                                        (when
                                         (= tin-status :country-does-not-issue-tin)
                                          (kyc-options/resolve-tin-status-label tin-status lang-kw))]
                                       (remove cu/blank-value?)
                                       (string/join " - "))
                           :style :value})))
                 (doall))}))

(defmethod to-pdfmake-content-complex :edn-data.type/source-of-funds-allocation-split
  [{:keys [value lang-kw]}]
  (let [splits value]
    {:table {:widths     ["auto" "auto"]
             :margin     [4 4 4 4]
             :headerRows 1
             :body       (concat
                          [[{:text        (loc/tr :source-of-fund-category nil lang-kw)
                             :border      [true true true true]
                             :borderColor ["#DDD" "#DDD" "#DDD" "#DDD"]
                             :fillColor   "#EEE"}
                            {:text        (loc/tr :percentage nil lang-kw)
                             :border      [true true true true]
                             :borderColor ["#DDD" "#DDD" "#DDD" "#DDD"]
                             :fillColor   "#EEE"}]]
                          (->> splits
                               (map (fn [[k v]]
                                      [{:text        (ku/localize-option
                                                      {:options kyc-options/source-of-funds-options}
                                                      []
                                                      k
                                                      lang-kw)
                                        :border      [true true true true]
                                        :borderColor ["#DDD" "#DDD" "#DDD" "#DDD"]}
                                       {:text        (fu/format-percentage v)
                                        :border      [true true true true]
                                        :borderColor ["#DDD" "#DDD" "#DDD" "#DDD"]}]))
                               (vec)))}}))

(defmethod to-pdfmake-content-complex :edn-data.type/split-of-investment-portfolio
  [{:keys [value lang-kw]}]
  (let [splits value]
    {:table {:widths     ["auto" "auto"]
             :margin     [4 4 4 4]
             :headerRows 1
             :body       (concat [[{:text        (loc/tr :portfolio-investment-category nil lang-kw)
                                    :border      [true true true true]
                                    :borderColor ["#DDD" "#DDD" "#DDD" "#DDD"]
                                    :fillColor   "#EEE"}
                                   {:text        (loc/tr :percentage nil lang-kw)
                                    :border      [true true true true]
                                    :borderColor ["#DDD" "#DDD" "#DDD" "#DDD"]
                                    :fillColor   "#EEE"}]]
                                 (->> splits
                                      (map (fn [[k v]]
                                             [{:text        (ku/localize-option
                                                             {:options
                                                              kyc-options/split-of-investments-options}
                                                             []
                                                             k
                                                             lang-kw)
                                               :border      [true true true true]
                                               :borderColor ["#DDD" "#DDD" "#DDD" "#DDD"]}
                                              {:text        (fu/format-percentage v)
                                               :border      [true true true true]
                                               :borderColor ["#DDD" "#DDD" "#DDD" "#DDD"]}]))
                                      (vec)))}}))

(defmethod to-pdfmake-content-complex :edn-data.type/flow-through-ownership-jurisdictions
  [{:keys [value lang-kw] :as args}]
  (let [jurisdictions (or value [])
        questions (-> args
                      :data/template
                      :kyc-flow-through-jurisdiction.group/basic-information
                      :questions)
        headers [:kyc-flow-through-jurisdiction/jurisdiction
                 :kyc-flow-through-jurisdiction/ownership-percent
                 :kyc-flow-through-jurisdiction/taxable-percent
                 :kyc-flow-through-jurisdiction/tax-exempt-percent
                 :kyc-flow-through-jurisdiction/is-transparent
                 :kyc-flow-through-jurisdiction/is-taxed-as-income-arises
                 :kyc-flow-through-jurisdiction/notes]
        widths ["15%" "10%" "10%" "10%" "15%" "15%" "15%"]]
    (if (empty? jurisdictions)
      {:table {:widths     widths
               :headerRows 1
               :body       (concat
                            [(->> (range (count headers))
                                  (mapv (fn [i]
                                          {:text      (if (= i 0) (ku/localize args [] lang-kw) "")
                                           :style     :table-header
                                           :margin    [0 2 0 2]
                                           :colSpan   (count headers)
                                           :border    [false false false false]
                                           :fillColor "#FFFFFF"})))]
                            [(->> (range (count headers))
                                  (mapv (fn [i]
                                          {:text      (if (= i 0) "-" "")
                                           :border    [false false false false]
                                           :fillColor "#FFFFFF"})))])}}

      {:table
       {:widths     widths
        :headerRows 2
        :body
        (concat
         [(->> (range (count headers))
               (mapv (fn [i]
                       {:text      (if (= i 0) (ku/localize args [] lang-kw) "")
                        :style     :table-header
                        :margin    [0 2 0 2]
                        :colSpan   (count headers)
                        :border    [false false false true]
                        :fillColor "#FFFFFF"})))]
         [(->> headers
               (mapv (fn [attr]
                       {:text        (-> questions
                                         (get attr)
                                         :translations
                                         (get lang-kw))
                        :border      [true true true true]
                        :borderColor ["#DDD" "#DDD" "#DDD" "#DDD"]
                        :fillColor   "#EEE"})))]
         (->>
          jurisdictions
          (mapv
           (fn [row]
             (let [jurisdiction (:kyc-flow-through-jurisdiction/jurisdiction row)
                   jurisdiction-label (cond
                                        ;; Backwards compatability due a bug writing country keywords as strings
                                        (and (string? jurisdiction)
                                             (not (cu/empty-value? jurisdiction)))
                                        (some-> jurisdiction
                                                keyword
                                                country/get-label)

                                        (keyword? jurisdiction)
                                        (country/get-label jurisdiction)

                                        :else "")
                   ownership (fu/format-percentage (:kyc-flow-through-jurisdiction/ownership-percent row))
                   taxable (when (contains? row :kyc-flow-through-jurisdiction/taxable-percent)
                             (fu/format-percentage (:kyc-flow-through-jurisdiction/taxable-percent row)))
                   tax-exempt (when (contains? row :kyc-flow-through-jurisdiction/tax-exempt-percent)
                                (fu/format-percentage (:kyc-flow-through-jurisdiction/tax-exempt-percent row)))
                   transparent (let [v (:kyc-flow-through-jurisdiction/is-transparent row)]
                                 (when (some? v)
                                   (ku/localize-option {:options kyc-options/yes-no-options} [] v lang-kw)))
                   taxed-as-income (let [v (:kyc-flow-through-jurisdiction/is-taxed-as-income-arises row)]
                                     (when (some? v)
                                       (ku/localize-option {:options kyc-options/yes-no-options} [] v lang-kw)))
                   notes (:kyc-flow-through-jurisdiction/notes row)]
               (->> [jurisdiction-label ownership taxable tax-exempt transparent taxed-as-income notes]
                    (mapv (fn [text-value]
                            {:text        (or text-value "")
                             :border      [true true true true]
                             :style       :value
                             :borderColor ["#DDD" "#DDD" "#DDD" "#DDD"]}))))))))}})))

;; Type of Controlling Person renderer
;; Renders a "card" per entity account holder name, and within each card
;; shows checkboxes (checked/unchecked) for all available control type options.
(defmethod to-pdfmake-content-complex :edn-data.type/type-of-controlling-person
  [{:keys [value lang-kw options answers]}]
  (let [entity-names (or (:kyc-controlling-person/lifeline-legal-names-of-the-entity-account-holders-for-which-is-controlling-person answers)
                         [])
        selection-map (or value {})]
    (if (seq entity-names)
      {:stack
       (->> entity-names
            (map (fn [item-label]
                   (let [selected-for-item (set (get selection-map item-label))]
                     {:table  {:widths ["*"]
                               :body   [[{:border      [true true true true]
                                          :borderColor ["#DDD" "#DDD" "#DDD" "#DDD"]
                                          :fillColor   "#FDFDFD"
                                          :stack       (vec
                                                        (concat
                                                         [{:text  (str item-label)
                                                           :style :value}]
                                                         (->> options
                                                              (map (fn [opt]
                                                                     (let [opt-key (:key opt)
                                                                           checked? (contains? selected-for-item opt-key)
                                                                           label (ku/localize opt [] lang-kw)]
                                                                       {:columns
                                                                        [{:image  (if checked?
                                                                                    square-check-big-icon-data-url-v2
                                                                                    square-icon-data-url-v2)
                                                                          :width  10
                                                                          :height 10}
                                                                         {:width    "*"
                                                                          :text     label
                                                                          :style    :value
                                                                          :fontSize 10
                                                                          :margin   [5 0 0 0]}]
                                                                        :margin [0 5 3 5]})))
                                                              (doall))))}]]}
                      :margin [0 8 0 5]})))
            (doall))}
      {:text  "-"
       :style :value})))

(defmulti to-pdfmake-content :data/type)

(defmethod to-pdfmake-content :default
  [args]
  (logging/warn "KYC data type not supported to PDFMake conversion " (:data/type args))
  {:text  (str (:value args))
   :style :value})

(defmethod to-pdfmake-content :data.type/boolean
  [{:keys [value lang-kw]
    :or   {lang-kw :en}
    :as   args}]
  (if (-> args :editor/type
          (= :editor.type/checkbox))
    {:stack
     [{:columns
       [{:image  (if value
                   square-check-big-icon-data-url-v2
                   square-icon-data-url-v2)
         :width  10
         :height 10}
        {:width    "*"
         :text     (get-in args [:translations lang-kw])
         :style    :value
         :fontSize 10
         :margin   [5 0 0 0]}]
       :margin [0 8 0 5]}]}
    {:text  (cond (false? value)
                  (loc/tr :false)
                  (nil? value)
                  "-"
                  :else
                  (loc/tr :true))
     :style :value}))

(defmethod to-pdfmake-content :data.type/confirm
  [{:keys [lang-kw value translations]
    :or   {lang-kw :en}
    :as   _args}]
  {:stack
   [{:columns
     [{:image  (if value
                 square-check-big-icon-data-url-v2
                 square-icon-data-url-v2)
       :width  10
       :height 10}
      {:width    "*"
       :text     (get translations lang-kw)
       :style    :value
       :fontSize 10
       :margin   [5 0 0 0]}]
     :margin [0 8 0 5]}]})

(defmethod to-pdfmake-content :data.type/currency-value
  [{:keys [value]}]
  {:text  (fu/format-with-separators (fu/bigdec->float value))
   :style :value})

(defmethod to-pdfmake-content :data.type/date
  [{:keys [value]}]
  {:text  (if (nil? value)
            "-"
            (fu/format-date-ts value "/"))
   :style :value})

(defmethod to-pdfmake-content :data.type/datetime
  [{:keys [value]}]
  {:text  (if (nil? value)
            "-"
            (fu/format-datetime-ts value "/"))
   :style :value})

(defmethod to-pdfmake-content :data.type/email
  [{:keys [value]}]
  {:text  value
   :link  (str "mailto:" value)
   :style :link})

(defmethod to-pdfmake-content :data.type/file
  [{:keys [value]}]
  {:text  (:attachment/filename (session/get-entity value))
   :style :file})

(defmethod to-pdfmake-content :data.type/keyword
  [{:keys [value lang-kw] :as args}]
  {:text  (if (nil? value)
            "-"
            (ku/localize-option args [] value lang-kw))
   :style :value})

(defmethod to-pdfmake-content :data.type/keyword-multi
  [{:keys [value lang-kw] :as args}]
  (let [options (:options args)
        key->option (when (seq options)
                      (into {} (map (juxt :key identity) options)))
        all-have-ord? (and (seq options)
                           (every? #(contains? % :ord) options))
        sorted-values (if all-have-ord?
                        (sort-by (fn [v]
                                   (get-in key->option [v :ord] 0))
                                 value)
                        (sort-by (fn [v]
                                   (-> (ku/localize-option args [] v lang-kw)
                                       (or "")
                                       (string/lower-case)))
                                 value))]
    {:stack (->> sorted-values
                 (map (fn [v]
                        {:text  (ku/localize-option args [] v lang-kw)
                         :style :value}))
                 (doall))}))

(defmethod to-pdfmake-content :data.type/percentage
  [{:keys [value]}]
  {:text  (fu/format-percentage value)
   :style :value})

(defmethod to-pdfmake-content :data.type/text
  [{:keys [value]}]
  {:text  (if (cu/blank-value? value)
            "-"
            (str value))
   :style :value})

(defmethod to-pdfmake-content :data.type/info
  []
  {:text  ""
   :style :value})

(defmethod to-pdfmake-content :data.type/text-edn
  [args]
  (to-pdfmake-content-complex args))

(defmethod to-pdfmake-content :data.type/text-multiline
  [{:keys [value]}]
  {:text  (if (cu/blank-value? value)
            "-"
            (str value))
   :style :value})

(def empty-spaces (apply str (take 80 (repeat " "))))

(defmethod to-pdfmake-content :data.type/text-simple
  [{:keys [value]}]
  (let [value-str (str value " ")]                                                                  ;; ensure at least space -> pdfmake does not render row at all
    {:text  value-str
     :style :value}))

(defmethod to-pdfmake-content :data.type/text-url
  [{:keys [value]}]
  {:text  (if (cu/blank-value? value)
            "-"
            (str value))
   :link  (str value)
   :style :link})

(comment
  ["verify these are ok !!"
   :data.type/confirm
   :data.type/file
   :data.type/percentage
   :data.type/text-edn
   :data.type/text-url])

(defn to-pdfmake-answer
  [q m answers lang-kw]
  (to-pdfmake-content (assoc m
                             :question-kw q
                             :value (get answers q)
                             :lang-kw lang-kw
                             :answers answers)))

(defn to-pdfmake-entity
  [{:keys [template-schema answers kyc-process lang-kw]}]
  (->>
   template-schema
   (remove (fn [[_ section-meta]]
             (editor-utils/hide-section? answers kyc-process section-meta)))
   (remove (fn [[_ section-meta]]
             (:end-of-pdf? section-meta)))
   (sort-by (fn [[_ metadata]]
              (:ord metadata)))
   (map
    (fn [[_ section-metadata]]
      (let [visible-questions (->> section-metadata
                                   :questions
                                   (remove (fn [[_ m]]
                                             (editor-utils/hide-question? answers kyc-process m)))
                                   (sort-by (fn [[_ m]]
                                              (:ord m))))

            board-members-section? (-> section-metadata
                                       :questions
                                       :kyc-legal-entity/board-members-edn
                                       boolean)

            keep-together? (true? (:keep-together? section-metadata))
            info-only-section? (true? (:info-only-section? section-metadata))

            ; This may totally break if template schema is changed
            table
            (if board-members-section?
              (let [question (-> visible-questions
                                 first
                                 first)
                    meta (-> visible-questions
                             first
                             second
                             (assoc :kyc-process-status (:kyc-process/status kyc-process)))
                    board-members-table (-> (to-pdfmake-answer question meta answers lang-kw)
                                            :table)]
                (merge board-members-table
                       {:dontBreakRows      keep-together?
                        :keepWithHeaderRows keep-together?}))

              {:headerRows         1
               :widths             ["*"]
               :body               [[{:text      (ku/localize section-metadata [] lang-kw)
                                      :style     :table-header
                                      :margin    [0 2 0 2]
                                      :border    [false false false true]
                                      :fillColor "#FFFFFF"}]
                                    [{:border      [true true true true]
                                      :borderColor ["#DDD" "#DDD" "#DDD" "#DDD"]
                                      :fillColor   "#FDFDFD"
                                      :stack       (let [info-content (when info-only-section?
                                                                        (some-> section-metadata
                                                                                :info
                                                                                (get lang-kw)
                                                                                (html->pdfmake-content {:paragraph-style :preface})))
                                                         q-content (->> visible-questions
                                                                        (mapcat
                                                                         (fn [[q m]]
                                                                           (let [hide-label?
                                                                                 (or (-> m
                                                                                         :edn-data/type
                                                                                         (= :edn-data.type/combo-checkbox-selection))
                                                                                     (-> m
                                                                                         :data/type
                                                                                         (= :data.type/confirm))
                                                                                     (and (-> m
                                                                                              :data/type
                                                                                              (= :data.type/boolean))
                                                                                          (-> m
                                                                                              :editor/type
                                                                                              (= :editor.type/checkbox))))]
                                                                             (vec
                                                                              (concat
                                                                               (when-not hide-label?
                                                                                 [(pdfmake-question-label m lang-kw)])
                                                                               [(->> (to-pdfmake-answer q m answers lang-kw)
                                                                                     (doall))])))))
                                                                        (vec))]
                                                     (->> (concat info-content q-content)
                                                          (remove nil?)
                                                          (vec)))}]]
               :dontBreakRows      keep-together?
               :keepWithHeaderRows keep-together?})]
        [{:style  "tableExample"
          :margin [0 20 0 0]
          :table  table}])))))

(defn create-e-signature-achor-element
  "Docusign will use this string match to attach signature tab anchor to correct position on the pdf"
  [anchor-number]
  [{:text      (str "/e-signature-anchor-str-" anchor-number "/")
    :margin    [0 33 0 15]
    :noWrap    true
    :border    [false false false false]
    :color     "#FFFFFF"
    :fontSize  0.1}])

(defn to-pdfmake-end-sections
  [{:keys [template-schema answers kyc-process lang-kw e-sign-version?]}]
  (let [visible-sections (->> template-schema
                              (remove (fn [[_ section-meta]]
                                        (editor-utils/hide-section? answers kyc-process section-meta)))
                              (filter (fn [[_ section-meta]]
                                        (:end-of-pdf? section-meta)))
                              (sort-by (fn [[_ metadata]]
                                         (:ord metadata))))

        first-signature-section? (fn [section-kw]
                                   (some #{section-kw} [:kyc-legal-entity/signature
                                                        :kyc.natural-person/signature
                                                        :kyc-tenant/signature
                                                        :contract-kyc/signature]))
        second-signature-section? (fn [section-kw]
                                    (some #{section-kw} [:kyc-legal-entity/signature-2
                                                         :kyc-tenant/signature-2
                                                         :contract-kyc/signature-2]))
        visible-signature-sections (->> visible-sections
                                        (filterv (fn [[section-kw _]]
                                                   (or (first-signature-section? section-kw)
                                                       (second-signature-section? section-kw)))))]
    (->> visible-sections
         (map
          (fn [[section-kw section-metadata]]
            (let [visible-questions (->> section-metadata
                                         :questions
                                         (remove (fn [[_ m]]
                                                   (editor-utils/hide-question? answers kyc-process m)))
                                         (sort-by (fn [[_ m]]
                                                    (:ord m))))
                  keep-together? (true? (:keep-together? section-metadata))
                  info-only-section? (true? (:info-only-section? section-metadata))

                  section-title (if (and (first-signature-section? section-kw)
                                         (< 1 (count visible-signature-sections)))
                                  (loc/tr :signature-1 nil lang-kw)
                                  (ku/localize section-metadata [] lang-kw))]
              [{:style  "tableExample"
                :id     (str (when (:page-break-before? section-metadata)
                               START-NEW-PAGE-PREFIX)
                             "_end_pages_"
                             section-kw)
                :margin [0 20 0 0]
                :table  {:headerRows         1
                         :widths             ["*"]
                         :body               [[{:text      section-title
                                                :style     :table-header
                                                :margin    [0 2 0 2]
                                                :border    (if (and e-sign-version?
                                                                    (or (first-signature-section? section-kw)
                                                                        (second-signature-section? section-kw)))
                                                             [false false false false]
                                                             [false false false true])
                                                :fillColor "#FFFFFF"}]
                                              (cond
                                                (and e-sign-version?
                                                     (first-signature-section? section-kw))
                                                (create-e-signature-achor-element 1)

                                                (and e-sign-version?
                                                     (second-signature-section? section-kw))
                                                (create-e-signature-achor-element 2)

                                                :else
                                                [{:border      [true true true true]
                                                  :borderColor ["#DDD" "#DDD" "#DDD" "#DDD"]
                                                  :fillColor   "#FDFDFD"
                                                  :stack       (let [info-content (when info-only-section?
                                                                                    (some-> section-metadata
                                                                                            :info
                                                                                            (get lang-kw)
                                                                                            (html->pdfmake-content {:paragraph-style :preface})))
                                                                     q-content (->> visible-questions
                                                                                    (mapcat
                                                                                     (fn [[q m]]
                                                                                       [(pdfmake-question-label m lang-kw)
                                                                                        (->> (to-pdfmake-answer q
                                                                                                                m
                                                                                                                answers
                                                                                                                lang-kw)
                                                                                             (doall))]))
                                                                                    (vec))]
                                                                 (->> (concat info-content q-content)
                                                                      (remove nil?)
                                                                      (vec)))}])]
                         :dontBreakRows      keep-together?
                         :keepWithHeaderRows keep-together?}}]))))))

(defn to-pdfmake-ubo-pages
  [{:keys [template-schema answers kyc-process lang-kw]}]
  (let [ubo-templates (->> template-schema
                           (mapcat (fn [[_ section-meta]]
                                     (->> section-meta
                                          :questions
                                          (keep (fn [[_ questions-meta]]
                                                  (when (= :edn-data.type/ubo-list
                                                           (:edn-data/type questions-meta))
                                                    (:data/template questions-meta))))))))
        ;;TODO merge UBO templates
        merged-ubo-template (first ubo-templates)]
    (->> template-schema
         (mapcat (fn [[_ section-meta]]
                   (->> section-meta
                        :questions
                        (filter (fn [[_ question-meta]]
                                  (= :edn-data.type/ubo-list (:edn-data/type question-meta))))
                        (remove (fn [[_ question-meta]]
                                  (editor-utils/hide-question? answers kyc-process question-meta)))
                        (mapcat (fn [[q _]]
                                  (get answers q))))))
         (map (fn [ubo]
                {:pageBreakBefore true
                 :stack
                 [{:text  (ku/localize merged-ubo-template [:kyc-template/kyc-form-preface] lang-kw)
                   :id    (ubo-pdfmake-id ubo)
                   :style :main-heading}
                  (to-pdfmake-entity
                   {:template-schema merged-ubo-template
                    :answers         ubo
                    :kyc-process     kyc-process
                    :lang-kw         lang-kw})]})))))

(defn to-pdfmake-smo-pages
  [{:keys [template-schema answers kyc-process lang-kw]}]
  (let [smo-templates (->> template-schema
                           (mapcat (fn [[_ section-meta]]
                                     (->> section-meta
                                          :questions
                                          (keep (fn [[_ questions-meta]]
                                                  (when (= :edn-data.type/smo-list
                                                           (:edn-data/type questions-meta))
                                                    (:data/template questions-meta))))))))
        merged-smo-template (first smo-templates)]
    (->> template-schema
         (mapcat (fn [[_ section-meta]]
                   (->> section-meta
                        :questions
                        (filter (fn [[_ question-meta]]
                                  (= :edn-data.type/smo-list (:edn-data/type question-meta))))
                        (remove (fn [[_ question-meta]]
                                  (editor-utils/hide-question? answers kyc-process question-meta)))
                        (mapcat (fn [[q _]]
                                  (get answers q))))))
         (map (fn [smo]
                {:pageBreakBefore true
                 :stack
                 [{:text  (ku/localize merged-smo-template [:kyc-template/kyc-form-preface] lang-kw)
                   :id    (smo-pdfmake-id smo)
                   :style :main-heading}
                  (to-pdfmake-entity
                   {:template-schema merged-smo-template
                    :answers         smo
                    :kyc-process     kyc-process
                    :lang-kw         lang-kw})]})))))

(defn to-pdfmake-pep-pages
  [{:keys [template-schema answers kyc-process lang-kw]}]
  (let [pep-templates (->> template-schema
                           (mapcat (fn [[_ section-meta]]
                                     (->> section-meta
                                          :questions
                                          (keep (fn [[_ questions-meta]]
                                                  (when (= :edn-data.type/pep-list
                                                           (:edn-data/type questions-meta))
                                                    (:data/template questions-meta))))))))
        ;;TODO merge PEP templates
        merged-pep-template (first pep-templates)]
    (->> template-schema
         (mapcat (fn [[_ section-meta]]
                   (->> section-meta
                        :questions
                        (filter (fn [[_ question-meta]]
                                  (= :edn-data.type/pep-list (:edn-data/type question-meta))))
                        (remove (fn [[_ question-meta]]
                                  (editor-utils/hide-question? answers kyc-process question-meta)))
                        (mapcat (fn [[q _]]
                                  (get answers q))))))
         (map (fn [pep]
                {:pageBreakBefore true
                 :stack
                 [{:text  (ku/localize merged-pep-template [:kyc-template/kyc-form-preface] lang-kw)
                   :id    (pep-pdfmake-id pep)
                   :style :main-heading}
                  (to-pdfmake-entity
                   {:template-schema merged-pep-template
                    :answers         pep
                    :kyc-process     kyc-process
                    :lang-kw         lang-kw})]})))))

(defn to-pdfmake-substantial-us-owner-pages
  [{:keys [template-schema answers kyc-process lang-kw]}]
  (let [suso-templates (->> template-schema
                            (mapcat (fn [[_ section-meta]]
                                      (->> section-meta
                                           :questions
                                           (keep (fn [[_ questions-meta]]
                                                   (when (= :edn-data.type/substantial-us-owner-list
                                                            (:edn-data/type questions-meta))
                                                     (:data/template questions-meta))))))))
        merged-suso-template (first suso-templates)]
    (->> template-schema
         (mapcat (fn [[_ section-meta]]
                   (->> section-meta
                        :questions
                        (filter (fn [[_ question-meta]]
                                  (= :edn-data.type/substantial-us-owner-list (:edn-data/type question-meta))))
                        (remove (fn [[_ question-meta]]
                                  (editor-utils/hide-question? answers kyc-process question-meta)))
                        (mapcat (fn [[q _]]
                                  (get answers q))))))
         (map (fn [suso]
                {:pageBreakBefore true
                 :stack
                 [{:text  (ku/localize merged-suso-template [:kyc-template/kyc-form-preface] lang-kw)
                   :id    (substantial-us-owner-pdfmake-id suso)
                   :style :main-heading}
                  (to-pdfmake-entity
                   {:template-schema merged-suso-template
                    :answers         suso
                    :kyc-process     kyc-process
                    :lang-kw         lang-kw})]})))))

(defn to-pdfmake-controlling-person-pages
  [{:keys [template-schema answers kyc-process lang-kw]}]
  (let [cper-templates (->> template-schema
                            (mapcat (fn [[_ section-meta]]
                                      (->> section-meta
                                           :questions
                                           (keep (fn [[_ questions-meta]]
                                                   (when (= :edn-data.type/controlling-person-list
                                                            (:edn-data/type questions-meta))
                                                     (:data/template questions-meta))))))))
        merged-cper-template (first cper-templates)]
    (->> template-schema
         (mapcat (fn [[_ section-meta]]
                   (->> section-meta
                        :questions
                        (filter (fn [[_ question-meta]]
                                  (= :edn-data.type/controlling-person-list (:edn-data/type question-meta))))
                        (remove (fn [[_ question-meta]]
                                  (editor-utils/hide-question? answers kyc-process question-meta)))
                        (mapcat (fn [[q _]]
                                  (get answers q))))))
         (remove nil?)
         (distinct)
         (map-indexed (fn [idx cper]
                        (when (or (:kyc-controlling-person/first-name cper)
                                  (:kyc-controlling-person/last-name cper))
                          {:pageBreakBefore true
                           :stack
                           [{:text  (ku/localize merged-cper-template [:kyc-template/kyc-form-preface] lang-kw)
                             :id    (controlling-person-pdfmake-id idx cper)
                             :style :main-heading}
                            (to-pdfmake-entity
                             {:template-schema merged-cper-template
                              :answers         cper
                              :kyc-process     kyc-process
                              :lang-kw         lang-kw})]})))
         (remove nil?))))

(defn template->pdfmake-content
  [{:keys [state-atom entity e-sign-version?]}]
  (let [lang (:kyc-process/language entity)
        lang-kw (languages/long->short lang)
        template-kw (:kyc-process/template entity)
        tenant-kyc-template? (some #{template-kw} templates/tenant-template-keys)
        template-schema (template-registry/templates template-kw)
        answers-atom (r/cursor state-atom [:kyc-process/answers])
        kyc-process entity
        pdfmake-page-params {:template-schema template-schema
                             :answers         @answers-atom
                             :kyc-process     kyc-process
                             :lang-kw         lang-kw
                             :e-sign-version? e-sign-version?}
        logo-width (if (number? (:kyc-template/png-logo-print-width template-schema))
                     (:kyc-template/png-logo-print-width template-schema)
                     150)
        logo-margins (if (and (vector? (:kyc-template/png-logo-print-margins template-schema))
                              (->> template-schema
                                   :kyc-template/png-logo-print-margins
                                   (every? number?)))
                       (:kyc-template/png-logo-print-margins template-schema)
                       [-20 0 0 0])]
    {:pageBreakBefore (fn [currentNode followingNodesOnPage nodesOnNextPage _previousNodesOnPage]
                        (let [current-node (js->clj currentNode :keywordize-keys true)
                              following-nodes-same-page (js->clj followingNodesOnPage
                                                                 :keywordize-keys
                                                                 true)
                              nodes-on-next-page (js->clj nodesOnNextPage :keywordize-keys true)
                              explicit-page-break? (when-let [id (:id current-node)]
                                                     (and (string? id)
                                                          (string/starts-with?
                                                           id
                                                           START-NEW-PAGE-PREFIX)))
                              break-before? (or explicit-page-break?
                                                (and (seq nodes-on-next-page)
                                                     (:stack current-node)
                                                     (->> following-nodes-same-page
                                                          (filter :stack)
                                                          (empty?))
                                                     (->> nodes-on-next-page
                                                          (first)
                                                          :stack
                                                          (not))))]
                          break-before?))
     :content         [{:image  :logo
                        :width  logo-width
                        :margin logo-margins}
                       {:stack
                        (->>
                         [{:text  (-> template-schema
                                      :kyc-template/kyc-form-title
                                      :translations
                                      (get lang-kw))
                           :style :main-header}

                          (when-not tenant-kyc-template?
                            (-> template-schema
                                :kyc-template/kyc-form-preface
                                (get lang-kw)
                                (html->pdfmake-content {:paragraph-style :preface})
                                (vec)))

                          (to-pdfmake-entity pdfmake-page-params)

                          #_(to-pdfmake-board-member-pages pdfmake-page-params)
                          #_(to-pdfmake-board-member-table-page pdfmake-page-params)

                          (to-pdfmake-ubo-pages pdfmake-page-params)

                          (to-pdfmake-smo-pages pdfmake-page-params)

                          (to-pdfmake-pep-pages pdfmake-page-params)

                          (to-pdfmake-substantial-us-owner-pages pdfmake-page-params)

                          (to-pdfmake-controlling-person-pages pdfmake-page-params)

                          (to-pdfmake-end-sections pdfmake-page-params)]
                         (remove nil?))}]
     :images          {:logo (str @db/server-url (:kyc-template/png-logo template-schema))}
     :styles          {:main-header  {:fontSize 12
                                      :bold     true
                                      :margin   [0 0 0 20]}
                       :subheader    {:fontSize 15
                                      :bold     true}
                       :table-header {:fontSize 12
                                      :bold     true}
                       :quote        {:italics true}
                       :preface      {:fontSize  8
                                      :alignment "justify"
                                      :color     "#666666"
                                      :margin    [0 0 0 4]}
                       :label        {:fontSize 8
                                      :bold     false
                                      :margin   [0 4 0 0]
                                      :color    "#999999"}
                       :link         {:fontSize   11
                                      :bold       false
                                      :margin     [4 4 4 4]
                                      :decoration "underline"
                                      :color      "blue"}
                       :value        {:fontSize 11
                                      :bold     false
                                      :margin   [4 4 4 4]
                                      :color    "#333333"}
                       :file         {:fontSize 11
                                      :bold     false
                                      :margin   [4 4 4 4]
                                      :color    "#333333"}
                       :input-line   {:fontSize   11
                                      :bold       false
                                      :margin     [4 4 4 4]
                                      :decoration "underline"
                                      :color      "#333333"}}}))

#_(defn show-as-pdf!
    [state-atom local-atom entity]
    (let [doc-definition (template->pdfmake-content state-atom entity)
          pdfDoc (.call (aget js/pdfMake "createPdf") js/pdfMake (clj->js doc-definition))]
      (.call (aget pdfDoc "getDataUrl")
             pdfDoc
             (fn [outdoc]
               (aset (.getElementById js/document "pdf-frame") "src" outdoc)))))

(defn save-as-pdf!
  [{:keys [state-atom entity e-sign-version?]}]
  (let [doc-definition (template->pdfmake-content {:entity entity
                                                   :state-atom state-atom
                                                   :e-sign-version? e-sign-version?})
        pdfDoc (.call (aget js/pdfMake "createPdf") js/pdfMake (clj->js doc-definition))]
    (.call (aget pdfDoc "print") pdfDoc)))

(defn pdf-blob
  [{:keys [state-atom entity e-sign-version? callback-fn]}]
  (let [doc-definition (template->pdfmake-content {:entity entity
                                                   :state-atom state-atom
                                                   :e-sign-version? e-sign-version?})
        pdfDoc (.call (aget js/pdfMake "createPdf") js/pdfMake (clj->js doc-definition))]
    (.call (aget pdfDoc "getBlob") pdfDoc callback-fn)))
